export const OPTION_TYPES = {
    level: 'level',
    duration: 'duration',
    players: 'players',
    legionaries: 'legionaries',
}


// WEBPACK FOOTER //
// ./components/BattleWizard/components/Option/constants.js